import { render, staticRenderFns } from "./AccountForwardersView.vue?vue&type=template&id=e98c1118&"
import script from "./AccountForwardersView.vue?vue&type=script&lang=js&"
export * from "./AccountForwardersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e98c1118')) {
      api.createRecord('e98c1118', component.options)
    } else {
      api.reload('e98c1118', component.options)
    }
    module.hot.accept("./AccountForwardersView.vue?vue&type=template&id=e98c1118&", function () {
      api.rerender('e98c1118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountForwardersView.vue"
export default component.exports